import Vue from 'vue'
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'

for (let rule in rules) {
  extend(rule, rules[rule])
}

// Register it globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
